module.exports = __webpack_public_path__ + "static/media/TIL-KA Construction Inc. - Notice of Proposal for Compliance Order - February 19- 2025.cd4272dc.pdf";